import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import { NAVIGATION_CONFIG } from '@v2/pages/common/constants/base.constants';
import { productionOrderDetailsConfig } from './config';

const ProductionOrderDetailsStack = createStackNavigator();

const ProductionOrderDetailsNavigator = () => {
  return (
    <ProductionOrderDetailsStack.Navigator screenOptions={NAVIGATION_CONFIG}>
      {productionOrderDetailsConfig.map(({ Component, name }) => (
        <ProductionOrderDetailsStack.Screen key={name} name={name} component={Component} />
      ))}
    </ProductionOrderDetailsStack.Navigator>
  );
};

export { ProductionOrderDetailsNavigator };
